import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactComponent as Cloud } from "./blob-bg.svg";

interface Props {
	color?: string;
	zIndex?: number;
	opacity?: number;
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
	root: {
		"& .a": {
			fill: ({ color }) => (color ? color : theme.palette.primary.main),
		},
	},
}));

export const BottomLeftCloud = ({ color, zIndex, opacity }: Props) => {
	const classes = useStyles({ color });
	return (
		<div style={{ position: "fixed", bottom: -72, left: 0, opacity: opacity || 0.7, zIndex: zIndex || -1 }}>
			<Cloud className={classes.root} width="100vw" preserveAspectRatio="none" />
		</div>
	);
};
